import cx from 'clsx';
import * as React from 'react';

import { SashLayerProps } from '@/components/game-tile/SashLayer/types';
import { COLORS } from '@/components/modular-grid/constants';

import styles from './SashLayer.module.scss';

const SashLayer = ({
  sash,
  textColor = COLORS.white,
  textBackgroundColor,
  background,
  outfit,
}: SashLayerProps) => {
  if (!sash) return null;

  return (
    <div
      className={cx(styles.container, {
        [styles.containerSmall]: outfit === 'small',
      })}
      style={{ background: background }}
      data-testid="sash-wrapper"
    >
      <span
        /**
         * In a situation when there is no color passed for the gradient, plain color will be displayed.
         * If there is no published text color in the CMS, we fallback to white color.
         */
        className={cx(styles.text, {
          [styles.textSmall]: outfit === 'small',
          [styles.textBackgroundColor]: textBackgroundColor,
        })}
        style={{
          color: textColor,
          backgroundImage: textBackgroundColor,
        }}
        data-testid="sash-text"
      >
        {sash}
      </span>
    </div>
  );
};

export default SashLayer;
